import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 78EC62FE-EC63-407F-BCF3-92C441398DDA
 * name triangle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle.svg
 * tags
 * - Shape 
 */
export const TriangleIcon = createSvgIcon(<><path d="M1,21H23L12,2" /></>, 'TriangleIcon');
export default TriangleIcon